import type {Reservation} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import type {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";
import {
    addMinutes,
    attachCurrentTimeToOtherDate,
    isSameDay,
} from "crqlar-react-common/dist/utils/date.util";
import {useService} from "crqlar-react-common/dist/utils/hooks/services/useServices";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useQueryClient} from "react-query";
import {RightSidebarCreateButton} from "../../../layout/rightSidebar/RightSidebarRail";
import ReservationDialog from "../../reservationDialog/ReservationDialog";

interface FloorplanCreateButtonProps {
    sector: Sector;
    restaurant: Resource;
    date: Date;
}

export function FloorplanCreateButton({sector, restaurant, date}: FloorplanCreateButtonProps) {
    const {t} = useTranslation();
    const defaultService = useService(sector.defaultServiceId);
    const queryClient = useQueryClient();
    const [reservation, setReservation] = useState<Reservation>();

    const handleCreate = () => {
        const now = new Date();
        const start = isSameDay(now, date) ? now : attachCurrentTimeToOtherDate(date);

        setReservation({
            resourceIds: restaurant.id ? [restaurant.id] : undefined,
            expectedStartDate: start,
            expectedEndDate: addMinutes(start, defaultService?.durationMinutes ?? 60),
            status: ReservationStatus.CONFIRMED,
            sectorId: sector.id,
            serviceId: defaultService?.id ?? sector.defaultServiceId,
        });
    };

    const handleSave = () => {
        setReservation(undefined);
        void queryClient.invalidateQueries(["floorplanAssigned"]);
        void queryClient.invalidateQueries(["floorplanUnassigned"]);
        void queryClient.invalidateQueries(["floorplanHalfboardProfiles"]);
        void queryClient.invalidateQueries(["floorplanRailSearch"]);
        void queryClient.invalidateQueries(["reservations"]);
    };

    return (
        <>
            <RightSidebarCreateButton
                label={t("Create reservation")}
                onClick={handleCreate}
            />

            <ReservationDialog
                open={Boolean(reservation)}
                reservation={reservation}
                onClose={() => setReservation(undefined)}
                onSave={handleSave}
                onChangeReservation={setReservation}
            />
        </>
    );
}
